import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLoginClick = () => {
    if (!email || !password) {
      alert("⚠️ Please enter both email and password!");
      return;
    }

    // ✅ Save login info locally
    localStorage.setItem("email", email);

    // redirect to home
    navigate('/home');
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <h1 className="project-title">Examify</h1>
        <p className="quote">"Empower Your Knowledge, Elevate Your Success"</p>
        <h2>Login</h2>

        <form
          className="auth-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleLoginClick();
          }}
        >
          <input
            type="email"
            placeholder="Email"
            className="auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" className="auth-button">
            Login
          </button>
        </form>

        <p className="auth-switch">
          Don't have an account?{' '}
          <span
            onClick={() => navigate('/register')}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            Register here
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
